import { SegmentedTabs } from "@akuna/ui";
import type { MedicalRecordPrimaryTab } from "./medical-record-mobile.types";

interface MobileMedicalRecordTab {
  value: MedicalRecordPrimaryTab;
  label: string;
}

interface MobileMedicalRecordTabsProps {
  activeTab: MedicalRecordPrimaryTab;
  tabs: MobileMedicalRecordTab[];
  onTabChange: (tab: MedicalRecordPrimaryTab) => void;
}

export function MobileMedicalRecordTabs({ activeTab, tabs, onTabChange }: MobileMedicalRecordTabsProps) {
  return (
    <div
      data-testid="medical-record-mobile-tabs"
      className="overflow-x-auto pb-0.5 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
    >
      <SegmentedTabs
        variant="outline"
        value={activeTab}
        onValueChange={(value) => onTabChange(value as MedicalRecordPrimaryTab)}
        items={tabs.map((tab) => ({
          value: tab.value,
          label: tab.label,
        }))}
      />
    </div>
  );
}
